{
	"title": "Transportation",
	"tabs": {
		"label": "Transportation sections",
		"overview": "Overview",
		"requests": "Requests",
		"fleet": "Drivers & vehicles",
		"trips": "Trips",
		"redispatchBadge_one": "{{count}} trip needs a vehicle again",
		"redispatchBadge_other": "{{count}} trips need a vehicle again"
	},
	"common": {
		"loading": "Loading…",
		"loadFailed": "Couldn't load this",
		"tryAgain": "Try again",
		"cancel": "Cancel",
		"done": "Done",
		"back": "Back"
	},
	"time": {
		"at": "{{time}} {{zone}}",
		"dayAt": "{{day}}, {{time}}",
		"unknown": "Time not known yet",
		"zoneNote": "Times are {{zone}}. Hover a time to see it in yours."
	},
	"duration": {
		"h": "{{h}} h",
		"m": "{{m}} min",
		"hm": "{{h}} h {{m}} min"
	},
	"day": {
		"label": "Day",
		"today": "Today",
		"previousWeek": "Previous week",
		"nextWeek": "Next week",
		"pick": "Pick a day",
		"backToToday": "Back to today",
		"waitingBadge": "Waiting for a transfer: {{arrivals}}, {{departures}}",
		"waitingArrivals_one": "{{n}} arriving",
		"waitingArrivals_other": "{{n}} arriving",
		"waitingDepartures_one": "{{n}} departing",
		"waitingDepartures_other": "{{n}} departing"
	},
	"status": {
		"label": {
			"PENDING": "Pending driver",
			"SHORT": "Partly assigned",
			"ASSIGNED": "Driver assigned",
			"EN_ROUTE": "En route",
			"PARTIAL": "Partly completed",
			"COMPLETED": "Trip completed",
			"CANCELLED": "Cancelled",
			"REJECTED": "Rejected"
		},
		"hint": {
			"PENDING": "No vehicle or driver yet",
			"SHORT": "Some passengers still have no seat",
			"ASSIGNED": "Every passenger has a seat",
			"EN_ROUTE": "At least one vehicle is on the road",
			"PARTIAL": "Some vehicles have arrived",
			"COMPLETED": "Every vehicle has arrived",
			"CANCELLED": "Cancelled",
			"REJECTED": "Rejected by the host"
		}
	},
	"allocationState": {
		"ASSIGNED": "Assigned",
		"EN_ROUTE": "En route",
		"DONE": "Arrived",
		"CANCELLED": "Cancelled"
	},
	"source": {
		"ARR": "Arrival",
		"DEP": "Departure",
		"ADHOC": "Venue trip"
	},
	"place": {
		"notSet": "Destination not set",
		"entryPoint": "{{code}} · {{name}}",
		"inCluster": "{{name}}, cluster {{cluster}}",
		"clusterOf": "Cluster: {{cluster}}",
		"kind": {
			"VENUE": "Venues",
			"ENTRY_POINT": "Entry points",
			"PLACE": "Hotels and other places"
		}
	},
	"org": {
		"host": "Host",
		"hostHint": "The host's own trip"
	},
	"passengers": {
		"title": "Passengers",
		"count_one": "{{n}} passenger",
		"count_other": "{{n}} passengers",
		"people_one": "{{n}} person",
		"people_other": "{{n}} people",
		"wheelchairUsers_one": "{{n}} wheelchair user",
		"wheelchairUsers_other": "{{n}} wheelchair users",
		"wheelchair": "Wheelchair user",
		"none": "Nobody is on this trip.",
		"unnamed_one": "{{n}} more person without a name (escort or head count)",
		"unnamed_other": "{{n}} more people without names (escorts or head count)",
		"meta": "{{number}} · {{org}}",
		"open": "Open {{name}}'s record",
		"lapsed": "No longer accredited",
		"flightCancelled": "Flight cancelled",
		"showAll_one": "Show all {{n}}",
		"showAll_other": "Show all {{n}}",
		"showFewer": "Show fewer"
	},
	"allocation": {
		"title": "Drivers & vehicles",
		"unassigned": "Unassigned",
		"line": "{{driver}} · {{pax}} pax",
		"change": "Change",
		"assign": "Assign a vehicle",
		"noneTitle": "No vehicle assigned",
		"noneHint": "Add one, or let Suggest pick free vehicles and drivers.",
		"noneReadOnly": "The transport desk assigns the vehicles.",
		"noneClosed": "This trip is closed.",
		"vehicle": "{{plate}} · {{model}}",
		"seats": "{{pax}} of {{seats}} seats",
		"start": "Start trip",
		"arrive": "Arrived",
		"started": "{{plate}} is on the road",
		"arrived": "{{plate}} has arrived",
		"stepFailed": "Couldn't update the vehicle"
	},
	"redispatch": {
		"tag": "Needs re-dispatch",
		"hint": "A delay moved this trip onto another trip of a vehicle or driver, so that vehicle was released. Assign again."
	},
	"recheck": {
		"tag": "Re-check",
		"hint": "A delay moved the pick-up outside the driver's shift or onto a rest day. The driver was kept; check with them."
	},
	"overview": {
		"tiles": {
			"label": "Transport at a glance",
			"pending": "Pending driver",
			"overdue_one": "{{n}} overdue",
			"overdue_other": "{{n}} overdue",
			"noneOverdue": "none overdue",
			"next24": "Next 24 h unassigned",
			"autoAssign": "Suggest vehicles",
			"allCovered": "all covered",
			"redispatch": "Needs re-dispatch",
			"reassign": "Assign again",
			"noneReleased": "no vehicle released",
			"road": "On the road",
			"onDuty": "Drivers on duty",
			"driving_one": "{{n}} driver driving",
			"driving_other": "{{n}} drivers driving",
			"ofDrivers_one": "of {{n}} · {{rest}} rest day",
			"ofDrivers_other": "of {{n}} · {{rest}} rest day",
			"fleet": "Fleet",
			"fleetMix": "{{bus}} buses · {{van}} vans · {{car}} cars"
		},
		"trips": {
			"title": "Trips by day",
			"openList": "Open as a list",
			"none": "No trips on {{day}}",
			"noneHint": "Pick another day above.",
			"more_one": "Showing {{shown}} of {{n}} trip.",
			"more_other": "Showing {{shown}} of {{n}} trips.",
			"moreNoTotal": "Showing the first {{shown}}."
		},
		"newTrip": "New trip"
	},
	"suggestions": {
		"title": "Suggested transfers",
		"direction": "Arrivals or departures",
		"arrivals": "Arrivals",
		"departures": "Departures",
		"pickup": "pick-up",
		"lands": "lands {{time}} {{zone}}",
		"departs": "departs {{time}} {{zone}}",
		"moreOrgs_one": "+{{n}} more",
		"moreOrgs_other": "+{{n}} more",
		"canMerge": "Can merge",
		"canMergeHint": "Another flight lands close to this one at the same airport and goes to the same place. Select both and merge them into one transfer.",
		"pick": "Select {{name}}",
		"selectAll_one": "Select the {{n}} suggestion",
		"selectAll_other": "Select all {{n}} suggestions",
		"selected_one": "{{n}} selected",
		"selected_other": "{{n}} selected",
		"selectedPeople_one": "{{n}} selected · {{people}} people",
		"selectedPeople_other": "{{n}} selected · {{people}} people",
		"create_one": "Create {{n}} transfer",
		"create_other": "Create {{n}} transfers",
		"merge": "Merge into one",
		"mergeHint": "Only suggestions from the same entry point to the same place can be merged",
		"dismiss": "No transport needed",
		"clearSelection": "Clear the selection",
		"tooMany": "At most {{max}} at a time",
		"truncated": "Only the first {{n}} groups are shown. Pick a single day or an entry point to see the rest.",
		"noneArrivals": "No arrivals waiting for a transfer on {{day}}",
		"noneDepartures": "No departures waiting for a transfer on {{day}}",
		"noneHint": "Approved people whose travel needs transport show up here until they are on a transfer.",
		"timeUnknown_one": "{{n}} person with no time yet",
		"timeUnknown_other": "{{n}} people with no time yet",
		"notApproved_one": "{{n}} person not approved yet",
		"notApproved_other": "{{n}} people not approved yet",
		"headCount": "{{people}} · {{groups}}",
		"peopleCount_one": "{{n}} person waiting",
		"peopleCount_other": "{{n}} people waiting",
		"groupCount_one": "{{n}} suggested transfer",
		"groupCount_other": "{{n}} suggested transfers",
		"next_one": "Next: {{day}} · {{n}} waiting",
		"next_other": "Next: {{day}} · {{n}} waiting",
		"journey": "Journey",
		"focus": {
			"inGroup_one": "This person is the only one in their group ({{service}}). Create their transfer below.",
			"inGroup_other": "This person rides in a group of {{n}} ({{service}}), highlighted below.",
			"waitingApproval": "This person is in the waiting list below: their record is not approved yet, so no transfer can be made.",
			"waitingTime": "This person is in the waiting list below: their travel has no time yet. Add it on the record to get a transfer.",
			"missing": "This person is not waiting for a transfer on {{day}}. They may be on one already, or not need one.",
			"journey_one": "{{n}} suggested transfer of this journey is highlighted · {{waiting}} waiting.",
			"journey_other": "{{n}} suggested transfers of this journey are highlighted · {{waiting}} waiting.",
			"journeyNone": "Nobody on this journey is waiting for a transfer on {{day}}.",
			"wholeGroup_one": "Create the transfer",
			"wholeGroup_other": "Create for the whole group ({{n}})",
			"onlyThis": "Only this person",
			"clear": "Stop highlighting"
		}
	},
	"create": {
		"title_one": "Create {{n}} transfer",
		"title_other": "Create {{n}} transfers",
		"mergeTitle": "Merge into one transfer",
		"sub_one": "{{people}} person",
		"sub_other": "{{people}} people",
		"mergeIntro": "Everyone below rides one transfer. The pick-up waits for the last flight to land.",
		"mergeTooBig": "One transfer holds at most {{max}} people. Merge fewer groups.",
		"dropoff": "Where they go",
		"pickupPlace": "Where they are picked up",
		"choosePlace": "Choose a place",
		"pickupNote": "Pick-up times follow the flights: landing plus the airport's walk-out time, or departure minus check-in and the drive.",
		"confirm_one": "Create {{n}} transfer",
		"confirm_other": "Create {{n}} transfers",
		"confirmMerge": "Create one transfer",
		"done_one": "Created {{n}} transfer",
		"done_other": "Created {{n}} transfers",
		"exists": "These people are already on a transfer.",
		"resultTitle": "Some people were left out",
		"resultCreated_one": "{{n}} transfer created.",
		"resultCreated_other": "{{n}} transfers created.",
		"resultSkipped_one": "{{n}} person was left out:",
		"resultSkipped_other": "{{n}} people were left out:",
		"skip": {
			"on_transfer": "Already on another transfer",
			"not_eligible": "No longer approved, or their travel changed",
			"not_in_scope": "Not yours to arrange"
		}
	},
	"dismiss": {
		"title_one": "No transport for this group?",
		"title_other": "No transport for these {{n}} groups?",
		"body_one": "{{n}} person will no longer be suggested for a transfer on this trip.",
		"body_other": "{{n}} people will no longer be suggested for a transfer on this trip.",
		"hint": "They come back if their travel is set to need transport again.",
		"confirm": "No transport needed",
		"done_one": "{{n}} person removed from the suggestions",
		"done_other": "{{n}} people removed from the suggestions",
		"failed": "Couldn't update the suggestions",
		"tooMany": "At most {{max}} people at a time. Pick fewer groups."
	},
	"attention": {
		"title": "Needs attention",
		"view": "View",
		"clear": "All clear",
		"clearHint": "Nothing needs you right now.",
		"REDISPATCH": {
			"title_one": "{{n}} trip lost a vehicle to a delay",
			"title_other": "{{n}} trips lost a vehicle to a delay",
			"hint": "The new time clashed with another trip. Assign a vehicle again.",
			"chip": "Lost a vehicle"
		},
		"OVERDUE": {
			"title_one": "{{n}} pick-up has passed with no driver",
			"title_other": "{{n}} pick-ups have passed with no driver",
			"hint": "Call the team lead, then assign or cancel.",
			"chip": "Overdue"
		},
		"RECHECK": {
			"title_one": "{{n}} assigned trip needs a re-check",
			"title_other": "{{n}} assigned trips need a re-check",
			"hint": "A delay moved the pick-up outside the driver's shift or onto a rest day.",
			"chip": "Re-check"
		},
		"FLIGHT_CANCELLED": {
			"title_one": "{{n}} trip follows a cancelled flight",
			"title_other": "{{n}} trips follow a cancelled flight",
			"hint": "Check the new travel with the team, then change or cancel the trip.",
			"chip": "Flight cancelled"
		},
		"NO_PASSENGERS": {
			"title_one": "{{n}} trip has nobody left on it",
			"title_other": "{{n}} trips have nobody left on them",
			"hint": "Their passengers were moved or rebooked. Cancel the trip if it is no longer needed.",
			"chip": "Nobody left"
		},
		"RAMP_NEEDED": {
			"title_one": "{{n}} trip needs a wheelchair ramp",
			"title_other": "{{n}} trips need a wheelchair ramp",
			"hint": "Only vans and buses marked with a ramp can take them.",
			"chip": "Ramp needed"
		},
		"MAINTENANCE_BOOKED": {
			"title_one": "{{n}} vehicle in maintenance still has trips booked",
			"title_other": "{{n}} vehicles in maintenance still have trips booked",
			"hint": "Move those trips to another vehicle.",
			"chip": "Vehicle in maintenance"
		},
		"noDestination": {
			"title_one": "{{n}} person waiting for a transfer has no destination",
			"title_other": "{{n}} people waiting for a transfer have no destination",
			"hint": "Neither a hotel room nor a contingent drop-off is known. Pick a place when you create the transfer."
		}
	},
	"autoAssign": {
		"title_one": "Suggest vehicles for {{n}} trip",
		"title_other": "Suggest vehicles for {{n}} trips",
		"sub_one": "{{n}} passenger · earliest pick-up first",
		"sub_other": "{{n}} passengers · earliest pick-up first",
		"rule": "For each trip: free, active vehicles in its cluster (the smallest that fits everyone, else the largest first), each with a driver certified for it, on shift, not on a rest day and not on another trip. Wheelchair users get seats in vehicles with a ramp.",
		"keepPartial": "Keep partly filled trips",
		"keepPartialHint": "When there are not enough vehicles, seat who fits and leave the trip as Partly assigned. Otherwise those trips are skipped.",
		"confirm_one": "Confirm {{n}} trip",
		"confirm_other": "Confirm {{n}} trips",
		"nothing": "None of these trips is waiting for a driver.",
		"firstOf": "The first {{shown}} of {{n}} trips, earliest first. Run it again for the rest.",
		"doneTitle": "Vehicles assigned",
		"assigned": "Assigned",
		"partial": "Partly assigned",
		"skipped": "Skipped",
		"reasonsTitle": "Not fully assigned, with the reason",
		"partlyFilled": "Partly assigned.",
		"toast_one": "Assigned vehicles to {{n}} trip",
		"toast_other": "Assigned vehicles to {{n}} trips",
		"reason": {
			"NOT_OPEN": "The trip is cancelled or rejected",
			"ALREADY_ASSIGNED": "It already has a vehicle",
			"PICKUP_PASSED": "Pick-up time has passed. Check with the team",
			"NO_PASSENGERS": "Nobody is on this trip",
			"NO_VEHICLE_FREE": "Not enough free vehicles in its cluster at that time",
			"NO_DRIVER_ON_SHIFT": "No certified driver on shift for the free vehicles",
			"NO_RAMP_VEHICLE": "No free vehicle with a ramp for the wheelchair users",
			"CONFLICT": "Another dispatcher took a vehicle or driver meanwhile. Try again",
			"NOT_DISPATCHABLE": "Not yours to dispatch",
			"other": "Not assigned"
		},
		"suggest": "Suggest vehicles",
		"reviewTitle_one": "{{n}} trip suggested",
		"reviewTitle_other": "{{n}} trips suggested",
		"reviewHint": "Nothing is saved yet. Untick any trip you want to arrange yourself, update the suggestion, then confirm.",
		"update_one": "Update suggestion ({{n}} left out)",
		"update_other": "Update suggestion ({{n}} left out)",
		"suggestAgain": "Suggest again",
		"changed": "Not saved: vehicles, drivers or trips changed since you reviewed. Suggest again.",
		"noPicks": "No vehicle to suggest.",
		"pick": "{{plate}} · {{driver}} · {{pax}} seats"
	},
	"cancel": {
		"title": "Cancel or reject",
		"selected_one": "{{n}} trip selected",
		"selected_other": "{{n}} trips selected",
		"cancel": "Cancel",
		"cancelHint": "The trip is no longer needed. Assigned drivers are released.",
		"reject": "Reject",
		"rejectHint": "Not a Games trip, or a duplicate. Only trips without a driver.",
		"nOf": "{{n}} of {{total}}",
		"cancelTitle_one": "Cancel {{n}} trip",
		"cancelTitle_other": "Cancel {{n}} trips",
		"rejectTitle_one": "Reject {{n}} trip",
		"rejectTitle_other": "Reject {{n}} trips",
		"requesterSees": "The requester sees the reason.",
		"leftAlone_one": "{{n}} selected trip is left alone: it is already on the road, done or closed.",
		"leftAlone_other": "{{n}} selected trips are left alone: they are already on the road, done or closed.",
		"tooMany": "At most {{max}} trips at a time.",
		"reason": "Reason",
		"reasonHint": "Say why, in a few words.",
		"reasonRequired": "Give a reason",
		"confirmCancel_one": "Cancel {{n}} trip",
		"confirmCancel_other": "Cancel {{n}} trips",
		"confirmReject_one": "Reject {{n}} trip",
		"confirmReject_other": "Reject {{n}} trips",
		"cancelled_one": "{{n}} trip cancelled",
		"cancelled_other": "{{n}} trips cancelled",
		"rejected_one": "{{n}} trip rejected",
		"rejected_other": "{{n}} trips rejected",
		"resultTitle": "Some trips were left alone",
		"resultDone_one": "{{n}} trip changed. These were not:",
		"resultDone_other": "{{n}} trips changed. These were not:",
		"skip": {
			"not_in_scope": "Not yours to change",
			"not_open": "Already cancelled or rejected",
			"in_progress": "A vehicle is on the road or assigned. Cancel it instead of rejecting"
		}
	},
	"requests": {
		"title": "Transport requests",
		"count_one": "{{n}} trip",
		"count_other": "{{n}} trips",
		"search": "Trip Reference, Contingent, Place or Requester",
		"filters": "Filters",
		"filtersCount": "Filters ({{n}})",
		"filtersApply": "Show trips",
		"filtersClear": "Clear",
		"filter": {
			"date": "Pick-up date",
			"source": "Source",
			"cluster": "Cluster",
			"contingent": "Contingent",
			"all": "All"
		},
		"tab": {
			"label": "Upcoming or past",
			"upcoming": "Upcoming",
			"past": "Past"
		},
		"chips": {
			"status": "Status",
			"wheelchair": "Wheelchair",
			"redispatch": "Needs re-dispatch"
		},
		"table": {
			"status": "Status / Ref",
			"pickup": "Pick-up ({{zone}})",
			"withReturn": "{{time}} · return {{back}}",
			"route": "Route",
			"passengers": "Passengers",
			"bags_one": "{{n}} bag",
			"bags_other": "{{n}} bags",
			"seated": "{{seated}} of {{n}} seated",
			"contingent": "Contingent",
			"vehicles": "Driver & vehicle",
			"open": "Open {{ref}}"
		},
		"bulk": {
			"selected_one": "{{n}} selected",
			"selected_other": "{{n}} selected",
			"waiting_one": "{{n}} waiting for a driver",
			"waiting_other": "{{n}} waiting for a driver",
			"noneWaiting": "none waiting for a driver",
			"cancel": "Cancel or reject",
			"autoAssign_one": "Suggest vehicles ({{n}})",
			"autoAssign_other": "Suggest vehicles ({{n}})",
			"tooMany": "At most {{max}} at a time",
			"clear": "Clear the selection"
		},
		"pager": {
			"showing_one": "Showing {{from}} to {{to}} of {{total}}",
			"showing_other": "Showing {{from}} to {{to}} of {{total}}",
			"showingNoTotal": "Showing {{from}} to {{to}}",
			"empty": "No trips"
		},
		"empty": {
			"filteredTitle": "No trips match",
			"filteredHint": "Try another status, or clear the filters.",
			"clear": "Clear filters",
			"noneUpcoming": "No upcoming trips",
			"nonePast": "No past trips",
			"noneHint": "Trips appear here once transfers are created from arrivals and departures, or a contingent requests a venue trip."
		}
	},
	"steps": {
		"label": "Trip progress",
		"requested": "Requested",
		"assigned": "Driver assigned",
		"enRoute": "En route",
		"completed": "Completed"
	},
	"detail": {
		"title": "Trip",
		"subtitle": "Transport request · {{org}}",
		"subtitleHost": "Transport request · Host",
		"back": "Back to requests",
		"backToList": "Back to requests",
		"notFound": "This trip doesn't exist, or you can't see it.",
		"cancelOrReject": "Cancel or reject",
		"closed": {
			"CANCELLED": "Cancelled.",
			"REJECTED": "Rejected."
		},
		"noReason": "No reason given.",
		"redispatchTitle": "Needs a vehicle again.",
		"redispatchBody": "A delay moved this trip onto another trip of a vehicle or driver, so that vehicle was released. Assign again.",
		"recheckTitle": "Re-check the driver.",
		"recheckBody": "A delay moved the pick-up outside the driver's shift or onto a rest day. The driver was kept; check with them or change the vehicle.",
		"passedTitle": "Pick-up time has passed.",
		"passedBody": "Call the team lead before assigning, or cancel the trip.",
		"passedBodyContact": "Call {{name}} before assigning, or cancel the trip.",
		"emptyTitle": "Nobody is left on this trip.",
		"emptyBody": "Its passengers were moved or rebooked. Cancel it if it is no longer needed.",
		"changedSeeHistory": "See History below for what changed."
	},
	"trip": {
		"title": "Trip",
		"change": "Change",
		"pickup": "Pick-up",
		"follows": "Follows {{service}}",
		"followsLate": "Follows {{service}} (+{{delay}})",
		"followsEarly": "Follows {{service}} (−{{delay}})",
		"fixedTime": "Fixed time",
		"road": "About {{duration}} on the road",
		"roadReturn": "About {{duration}} on the road · return pick-up {{time}} {{zone}}",
		"from": "From",
		"to": "To",
		"passengers": "Passengers",
		"bags_one": "{{n}} bag or equipment case",
		"bags_other": "{{n}} bags and equipment cases",
		"contact": "Contact",
		"requestedBy": "Requested by {{name}}",
		"travel": "Travel",
		"landsAt": "lands {{time}} {{zone}}",
		"departsAt": "departs {{time}} {{zone}}",
		"cluster": "Cluster",
		"clusterValue": "{{name}} ({{code}})",
		"clusterRoute": "{{from}} → {{to}}",
		"dispatchedFrom": "Vehicles from {{cluster}}",
		"remarks": "Remarks",
		"confirmed": "Assigned",
		"followsTravel": "Follows the travel",
		"openJourney": "Open this flight in Arrival & Departure"
	},
	"edit": {
		"title": "Change the trip",
		"sub": "A new time moves the assigned vehicles too. If one is busy then, it is released and the trip shows Needs re-dispatch.",
		"pickup": "Pick-up time",
		"follow": "Follow the flight",
		"followHint": "The pick-up moves with the flight's landing or departure.",
		"fixed": "Fixed time",
		"fixedHint": "The pick-up stays at the time below, whatever the flight does.",
		"date": "Date",
		"time": "Time ({{zone}})",
		"drive": "Minutes on the road",
		"driveHint": "Sets how long the vehicle and driver are held for this trip.",
		"cluster": "Dispatch cluster",
		"clusterHint": "Vehicles and drivers are offered from this cluster first.",
		"save": "Save changes",
		"saved": "Trip updated",
		"timeInvalid": "Enter a date and a time",
		"minutesInvalid": "Enter whole minutes, {{min}} to {{max}}"
	},
	"editor": {
		"vehicleN": "Vehicle {{n}}",
		"remove": "Remove vehicle {{n}}",
		"vehicle": "Vehicle",
		"driver": "Driver",
		"passengers": "Passengers",
		"chooseVehicle": "Choose a vehicle",
		"chooseDriver": "Choose a driver",
		"vehicleFirst": "Choose the vehicle first",
		"vehicleOption": "{{plate}} · {{seats}} seats · {{model}}",
		"vehicleOptionRamp": "{{plate}} · {{seats}} seats · {{model}} · ramp",
		"otherCluster": "Other cluster: {{cluster}}",
		"notInService": "In maintenance or retired",
		"vehicleBusy": "On {{ref}} at that time",
		"vehicleFree": "Free at that time",
		"driverOption": "{{name}} · {{from}}–{{to}}",
		"driversHere": "Drivers in this cluster",
		"driverBusy": "Driving {{ref}} at that time",
		"driverRest": "Rest day",
		"driverOffShift": "Off shift at that time",
		"driverUsual": "Usually drives this vehicle",
		"driverFree": "On shift and free",
		"emptyTitle": "No vehicle yet",
		"emptyHint": "Add one, or let Suggest pick free vehicles and drivers.",
		"add": "Add vehicle",
		"suggest": "Suggest",
		"suggested_one": "Suggested {{n}} vehicle. Check and confirm",
		"suggested_other": "Suggested {{n}} vehicles. Check and confirm",
		"partlySuggested_one": "Partly filled: {{n}} person still has no seat. {{why}}",
		"partlySuggested_other": "Partly filled: {{n}} people still have no seat. {{why}}",
		"nothingFree": "No free vehicle with a driver right now",
		"suggestFailed": "Couldn't suggest vehicles",
		"why": {
			"NO_DRIVER_ON_SHIFT": "No certified driver on shift for the free vehicles.",
			"NO_VEHICLE_FREE": "Not enough free vehicles in this cluster at that time.",
			"NO_RAMP_VEHICLE": "No free vehicle with a ramp for the wheelchair users."
		},
		"seated_one": "{{seated}} of {{n}} seated",
		"seated_other": "{{seated}} of {{n}} seated",
		"ready": "Ready to confirm.",
		"fixRows": "Fix the rows marked in red.",
		"acceptPartial_one": "Confirm with {{n}} person still without a seat (the trip shows Partly assigned)",
		"acceptPartial_other": "Confirm with {{n}} people still without a seat (the trip shows Partly assigned)",
		"optionsFailed": "Couldn't load the vehicles and drivers. Close and open the trip again.",
		"discard": "Discard changes",
		"confirm": "Confirm assignment",
		"save": "Save changes",
		"assignedToast_one": "Driver assigned",
		"assignedToast_other": "Drivers assigned",
		"savedToast": "Changes saved",
		"saveFailed": "Couldn't save the vehicles"
	},
	"check": {
		"thisVehicle": "This vehicle",
		"thisDriver": "This driver",
		"anotherTrip": "another trip",
		"VEHICLE_REQUIRED": "Choose a vehicle",
		"DRIVER_REQUIRED": "Choose a driver",
		"PAX_INVALID": "Enter a whole number of passengers",
		"OVER_CAPACITY": "{{vehicle}} seats {{seats}}. {{pax}} is too many",
		"OVER_CAPACITY_plain": "More passengers than seats",
		"VEHICLE_INACTIVE": "{{vehicle}} is in maintenance or retired",
		"VEHICLE_DUPLICATE": "{{vehicle}} is on this trip twice",
		"VEHICLE_BUSY": "{{vehicle}} is on {{ref}} at that time",
		"DRIVER_INACTIVE": "{{driver}} is no longer active",
		"DRIVER_NOT_CERTIFIED": "{{driver}} is not certified for this type of vehicle",
		"DRIVER_REST_DAY": "{{driver}} has a rest day then",
		"DRIVER_OFF_SHIFT": "{{driver}}'s shift is {{from}}–{{to}}",
		"DRIVER_OFF_SHIFT_plain": "The driver is off shift then",
		"DRIVER_DUPLICATE": "{{driver}} is on this trip twice",
		"DRIVER_BUSY": "{{driver}} is driving {{ref}} at that time",
		"NO_ROWS": "Add at least one vehicle",
		"SEATS_SHORT_one": "{{n}} more passenger to seat",
		"SEATS_SHORT_other": "{{n}} more passengers to seat",
		"SEATS_OVER_one": "Over by {{n}}. The trip is for {{total}} person",
		"SEATS_OVER_other": "Over by {{n}}. The trip is for {{total}} people",
		"RAMP_REQUIRED_one": "{{n}} wheelchair user needs a seat in a vehicle with a ramp",
		"RAMP_REQUIRED_other": "{{n}} wheelchair users need seats in vehicles with a ramp",
		"OTHER_CLUSTER": "A vehicle or driver is from another cluster. Check the drive time.",
		"unknown": "Check this row"
	},
	"history": {
		"title": "History",
		"none": "Nothing recorded yet",
		"more": "Show older",
		"created": "Created",
		"changed": "Changed",
		"removed": "Removed",
		"system": "GMS",
		"migration": "System update",
		"someone": "Someone",
		"byAgent": "{{name}} (AI assistant)",
		"passengersAdded_one": "{{n}} passenger added",
		"passengersAdded_other": "{{n}} passengers added",
		"passengersReleased_one": "{{n}} passenger released",
		"passengersReleased_other": "{{n}} passengers released",
		"passengersRemoved_one": "{{n}} passenger moved off",
		"passengersRemoved_other": "{{n}} passengers moved off",
		"vehiclesAdded_one": "{{n}} vehicle assigned",
		"vehiclesAdded_other": "{{n}} vehicles assigned",
		"vehiclesCancelled_one": "{{n}} vehicle released",
		"vehiclesCancelled_other": "{{n}} vehicles released",
		"vehiclesChanged_one": "{{n}} vehicle updated",
		"vehiclesChanged_other": "{{n}} vehicles updated"
	},
	"overSeated": {
		"tag_one": "{{n}} seat too many",
		"tag_other": "{{n}} seats too many",
		"hint_one": "{{seats}} seats held for {{n}} passenger. Smaller vehicles may do.",
		"hint_other": "{{seats}} seats held for {{n}} passengers. Smaller vehicles may do."
	},
	"waiting": {
		"title_one": "Waiting — not ready for a transfer yet ({{n}})",
		"title_other": "Waiting — not ready for a transfer yet ({{n}})",
		"hint": "Shown so you can see who is coming. A transfer can be made once the record is approved and the travel time is known.",
		"noTime": "No time",
		"at": "{{time}} {{zone}}",
		"reason": {
			"not_approved": "Not approved yet",
			"time_unknown": "No time yet"
		},
		"openRecord": "Open record",
		"firstOf": "Showing the first {{shown}} of {{n}}."
	},
	"calendar": {
		"titleArrivals": "Arrivals without a transfer",
		"titleDepartures": "Departures without a transfer",
		"upcoming": "Coming up",
		"none": "Nobody is waiting for a transfer",
		"waiting_one": "{{n}} person waiting",
		"waiting_other": "{{n}} people waiting"
	}
}
